import { render, staticRenderFns } from "./copyAdset.vue?vue&type=template&id=5ede4f14&scoped=true"
import script from "./copyAdset.vue?vue&type=script&lang=js"
export * from "./copyAdset.vue?vue&type=script&lang=js"
import style0 from "./copyAdset.vue?vue&type=style&index=0&id=5ede4f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede4f14",
  null
  
)

export default component.exports